import type { Profile, User } from '@/types';

export const hasFullStageAccess = (profile?: Profile | null): boolean =>
  Boolean(profile?.isAdmin);

export const canAppearAsResponsible = (profile?: Profile | null): boolean =>
  Boolean(profile && profile.canBeResponsible !== false);

export const getVisibleResponsible = (user?: User | null): User | null =>
  user && canAppearAsResponsible(user.profile) ? user : null;
